export const HONEYPOT_NAME = '__sizeid__';

export const HONEYPOT_STYLE: React.CSSProperties = {
  width: 1,
  height: 1,
  background: 'none',
  border: 'none',
  boxShadow: 'none',
  outline: 'none',
  margin: 0,
  padding: 0,
  position: 'absolute',
};
